var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("审核时间："+_vm._s(_vm._f("formatDate")(_vm.log.creationTime)))]),_c('p',[_vm._v(_vm._s(_vm.log.desc))]),_c('attachments-view',{attrs:{"host-id":_vm.log.id,"host-type":_vm.hostType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }